<template>
  <v-text-field
      v-bind="$attrs"
      dense
      outlined
      :clearable="clearable"
      @input="onInput"
      type="date"
      :error="error"
      :error-messages="error_message"
      :hide-details="!property_state_field_name"
  >
  </v-text-field>
</template>

<script>

export default {
  name: 'BaseFieldTime',
  inheritAttrs: false,
  props: {
    // value: {default: null},
    property_state: {default: null},
    property_state_field_name: {default: null},
    clearable: {default: false},
  },

  components: {},

  computed: {
    error() {
      // console.log('error', this.property_state_field_name)
      return !!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error
    },
    error_message() {
      if (!!!!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error)
        return this.property_state[this.property_state_field_name].error_message
    else
      return null
    },
  },

  methods: {
    onInput(event) {
      // console.log('onInput', event)
      if (event === '')
        this.$emit('input', null)
      else
        this.$emit('input', event)
    },
  },

  async mounted() {
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
